import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'

// Default to the light theme: Nuxt UI's useDark() follows the system preference when
// nothing is stored, so seed the persisted choice on first visit. A user's own toggle
// overwrites this and keeps winning on later visits.
if (!localStorage.getItem('vueuse-color-scheme')) {
    localStorage.setItem('vueuse-color-scheme', 'light')
}

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)

createSentry(app)
app.mount('#app')
